import React from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import Banner from "../images/trial.png";
import { useStateValue } from "../Stateprovider";

function Project({ order }) {
  const [{ locked }, dispatch] = useStateValue();

  return (
    <Card className="mt-2" style={{ minWidth: "18rem", maxWidth: "18rem" }}>
      <Card.Img variant="top" src={order.data.imageLink} />

      <Card.Body>
        <Card.Title>{order.data.title}</Card.Title>
        <Card.Text>{order.data.description}</Card.Text>
      </Card.Body>
      <Card.Footer>
        <Button variant="primary" href={order.data.downloadLink}>
          Download
        </Button>
      </Card.Footer>
    </Card>
  );
}

export default Project;
